export enum ContractType {
  B2B = 'b2b',
  EMPLOYMENT_CONTRACT = 'employment-contract',
  MANDATE_CONTRACT = 'mandate-contract',
}
